import { render } from "./HallofFameModal.vue?vue&type=template&id=84ca4f5a"
import script from "./HallofFameModal.vue?vue&type=script&lang=js"
export * from "./HallofFameModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__